import React from 'react';

import { HealthChartProvider } from '@contexts/index';

import type { TrackerType } from '@models/vital-sign';

import MetricCard from '@views/Records/HealthTracker/Drilldown/Content/index';

interface HealthTrackerProps {
  category: TrackerType;
  code: string;
}

export default function HealthTracker({ category, code }: HealthTrackerProps) {
  return (
    <HealthChartProvider category={category} code={code}>
      <MetricCard />
    </HealthChartProvider>
  );
}
